<template>
    <div>
        <div class="menu" :class="{'minimized': sidePanel.minimized || sidePanel.submenu, 'details': sidePanel.details}">
            <h1>
                <span>my</span>247ed.com
            </h1>

            <ul :class="{'hide-details': !sidePanel.details}">
                <router-link :to="{name: 'enrollments'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Return to Account" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-angles-left"></i>
                        </b-tooltip>
                        <span class="nav-title">Return to Account</span>
                        <div class="meta"></div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Course
                </li>

                <router-link :to="{name: 'course-welcome', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Course Information" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-chalkboard-teacher"></i>
                        </b-tooltip>
                        <span class="nav-title">Course Information</span>
                        <div class="meta"></div>
                    </li>
                </router-link>

                <!-- Study Plan for self-directed courses -->
                <router-link v-if="isSelfDirected" :to="{name: 'course-setup'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Course Study Plan" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clipboard-list-check"></i>
                        </b-tooltip>
                        <span class="nav-title">Course Study Plan</span>
                        <div class="meta">View and develop your custom study plan.</div>
                        <div class="meta mt-3" v-if="setupStatus === 'submitted'">
                            <i class="fas fa-clock has-text-warning mr-2 is-size-6"></i>Pending Approval
                        </div>
                        <div class="meta mt-3" v-else-if="setupStatus === 'changes_requested'">
                            <i class="fas fa-exclamation-triangle has-text-danger mr-2 is-size-6"></i>Changes Requested
                        </div>
                        <div class="meta mt-3" v-else-if="!setupStatus || setupStatus === 'draft'">
                            <i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action Required
                        </div>
                    </li>
                </router-link>

                <!-- Course Outline - blocked for self-directed if setup not approved -->
                <router-link :to="{name: 'course-outline', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active" v-if="!enrollment.isMissingRequiredApps && !requiresSetupApproval">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Course Outline" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-rectangle-list"></i>
                        </b-tooltip>
                        <span class="nav-title">Course Outline</span>
                        <div class="meta">Access the online course and lessons.</div>
                    </li>
                </router-link>
                <!-- Course Outline - disabled state for self-directed needing study plan -->
                <li v-else-if="requiresSetupApproval" @click="showSetupRequiredAlert" class="disabled-nav">
                    <b-tooltip label="Course Outline" position="is-right" append-to-body type="is-light" size="is-large">
                        <i class="fad fa-fw fa-rectangle-list"></i>
                    </b-tooltip>
                    <span class="nav-title">Course Outline</span>
                    <div class="meta">Access the online course and lessons.</div>
                    <div class="meta mt-3"><i class="fas fa-lock has-text-grey mr-2 is-size-6"></i>Study Plan Required</div>
                </li>
                <router-link :to="{name: 'course-applications', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active" v-else-if="enrollment.isMissingRequiredApps">
                    <li @click="navigate">
                        <b-tooltip label="Course Outline" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-rectangle-list"></i>
                        </b-tooltip>
                        <span class="nav-title">Course Outline</span>
                        <div class="meta">Access the online course and lessons.</div>

                        <div class="meta mt-3"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Unmet Requirements</div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Tools & Resources
                </li>

                <router-link :to="{name: 'enroll-notes', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Online Course Notes" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-memo-pad"></i>
                        </b-tooltip>
                        <span class="nav-title">Online Course Notes</span>
                        <div class="meta">View and edit online course notes.</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'enroll-files', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Files & Uploads" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-folder-arrow-up"></i>
                        </b-tooltip>
                        <span class="nav-title">Files & Uploads</span>
                        <div class="meta">Access course materials & upload your own attachments and work.</div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Enrollment & Records
                </li>

                <router-link :to="{name: 'study-log', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Study Log" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clipboard-list-check"></i>
                        </b-tooltip>
                        <span class="nav-title">Study Log</span>
                        <div class="meta">Log of online course activity, offline course work, and other qualifying activities.</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'enroll-reflections', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Milestones & Reflections" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-flag-swallowtail"></i>
                        </b-tooltip>
                        <span class="nav-title">Milestones & Reflections</span>
                        <div class="meta">Track and reflect on your course progress.</div>
                        <div class="meta mt-3" v-if="milestoneLock.locked"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'course-applications', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Certifications & Forms" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-certificate"></i>
                        </b-tooltip>
                        <span class="nav-title">Certifications & Forms</span>
                        <div class="meta">Apply for certifications and retrieve official completion forms or certificates.</div>
                        <!-- "Action Required" for required apps is readiness-gated: it appears
                             only once the student is genuinely done working (never earlier).
                             Required apps only — optional ones get the info hint below, even
                             after completion (completed courses can still apply) -->
                        <div class="meta mt-3" v-if="enrollment.isMissingRequiredApps || (enrollment.completed_at && enrollment.hasIncompleteEndRequiredApps) || (applicationReadiness && enrollment.hasIncompleteEndRequiredApps)"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                        <div class="meta mt-3" v-else-if="(applicationReadiness || enrollment.completed_at) && enrollment.hasIncompleteOptionalApps"><i class="fas fa-circle-info has-text-info mr-2 is-size-6"></i>Ready to Apply</div>
                    </li>
                </router-link>
            </ul>
        </div>
        <div class="controls ">
            <div class="columns is-gapless">
                <div class="column has-text-right">
                    <span @click="toggleDetails()" v-if="!sidePanel.minimized && !sidePanel.submenu"><i class="fad mt-2 mr-3" :class="{'fa-bars': sidePanel.details, 'fa-diagram-cells': !sidePanel.details}"></i></span>
                    <span @click="minimize(false)" v-if="sidePanel.minimized && !sidePanel.submenu"><i class="fad fa-chevrons-right mt-2"></i></span>
                    <span @click="minimize(true)" v-if="!sidePanel.submenu"><i class="fad fa-chevrons-left mt-2"></i></span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import pkg from '../../../package.json';
    import async from "async";
    import {client as http} from "../../http_client";


    export default {
        name: "CourseSideNav",
        data: function() {
            return {};
        },
        computed: {
            ...mapGetters(['currentUser', 'sidePanel', 'enrollment', 'milestoneLock', 'applicationReadiness']),
            isSelfDirected() {
                return this.enrollment &&
                       this.enrollment.course &&
                       this.enrollment.course.type === 'self_directed';
            },
            setupStatus() {
                return this.enrollment?.setup_status || null;
            },
            isSetupApproved() {
                return this.setupStatus === 'approved';
            },
            requiresSetupApproval() {
                return this.isSelfDirected && !this.isSetupApproved;
            }
        },
        methods: {
            ...mapActions(['getMilestoneLock']),
            refreshMilestoneLock: function() {
                if (this.isSelfDirected && this.isSetupApproved) {
                    this.getMilestoneLock(this.enrollment.id);
                } else {
                    // Different course type or enrollment — clear any stale lock state
                    this.$store.commit('SET_MILESTONE_LOCK', {locked: false, milestone: null});
                }
            },
            toggleDetails: function() {
                this.$store.commit('setDetails', !this.sidePanel.details);
            },
            minimize: function(state) {
                this.$store.commit('setMinimized', state);
            },
            showSetupRequiredAlert: function() {
                this.$buefy.dialog.alert({
                    title: 'Study Plan Required',
                    message: 'You must complete and have your study plan approved before you can access the course content. Please go to <strong>Course Study Plan</strong> to develop your plan.',
                    type: 'is-warning',
                    hasIcon: true,
                    icon: 'lock',
                    confirmText: 'OK'
                });
            }
        },
        watch: {
            'enrollment.id': function() {
                this.refreshMilestoneLock();
            }
        },
        mounted() {
            // TODO this doesn't support responsive
            this.$store.commit('setMinimized', false);
            // this.$store.commit('setDetails', false);
            this.refreshMilestoneLock();
        }
    };
</script>

<style lang="scss" scoped>
    .menu {
        position: absolute;
        top: 0;
        bottom: 32px;
        left: 0;
        right: 0;
        overflow-y: auto;

        background-color: #fff;
        background-image: linear-gradient(white, #eeeeee);

        h1 {
            font-weight: 400;
            font-size: 30px;
            margin-top: 1rem;
            display: inline-block;
            cursor: pointer;
            padding: 1rem 1.5rem 0;
            color: #4a4a4a;
            letter-spacing: -1px;

            span {
                font-weight: 900;
                margin-right: 3px;

                color: #336699;

                &.beta {
                    color: #333;
                    border: 1px solid #c2c2c2;
                    border-radius: 3px;
                    padding: 0 4px;
                    font-size: 0.6rem;
                    margin-left: 0.5rem;
                    vertical-align: super;
                    font-weight: normal;
                    letter-spacing: normal;
                }
            }
        }

        ul {
            margin-top: 1.1rem;

            li {
                border-bottom: 1px solid #e0e2e8;
                padding: 1rem 1.4rem;
                font-size: 1rem;
                color: #4a4a4a;
                transition: all 200ms;
                font-weight: bold;
                cursor: pointer;
                background-color: rgba(255, 255, 255, 0.5);

                &.active {
                    background-color: #336699 !important;

                    color: white;

                    .meta, i {
                        color: white;
                    }

                    &:first-child {
                        border-top: 1px solid #336699 !important;
                    }
                }

                &.sub-header {
                    font-weight: bold !important;
                    cursor: default !important;
                    color: #4a4a4a !important;
                    padding: 0.5rem 1.2rem 0.3rem !important;
                    font-size: 0.8rem !important;
                    text-transform: uppercase;
                    background-color: #f3f3f5 !important;
                }

                &:hover {
                    background-color: #567ea7;
                    color: white;

                    .meta, i {
                        color: white;
                    }
                }

                &.disabled-nav {
                    opacity: 0.6;
                    cursor: not-allowed;

                    &:hover {
                        background-color: rgba(255, 255, 255, 0.5);
                        color: #4a4a4a;

                        .meta {
                            color: #737881;
                        }

                        i {
                            color: #3c6691;
                        }
                    }
                }

                &:first-child {
                    border-top: 1px dashed #e0e2e8;
                }

                i {
                    color: #3c6691;
                    font-size: 1.5rem;
                    vertical-align: middle;
                    margin-right: 1.2rem;
                    transition: all 200ms;
                }

                .meta {
                    transition: color 200ms;

                    font-weight: normal;
                    font-size: 0.8rem;
                    padding-left: 3.15rem;
                    color: #737881;
                    line-height: 1rem;
                }
            }

            &.hide-details {
                li {
                    font-size: 0.9rem;
                    font-weight: normal;
                    padding: 0.8rem 1.4rem;

                    .meta {
                        display: none;
                    }

                    i {
                        font-size: 1.2rem;
                        margin-right: 0.8rem;
                    }
                }
            }
        }

        &.minimized {
            overflow: hidden;

            h1 {
                display: none;
            }

            ul {
                padding-top: 4.7rem;

                @media (max-width: 768px) {
                    padding-top: 0rem;
                }

                li {
                    padding: 1rem 1.1rem;

                    i {
                        font-size: 1.3rem;

                        @media (max-width: 768px) {
                            font-size: 1rem;
                        }
                    }

                    @media (max-width: 768px) {
                        padding: 0.8rem;
                    }

                    .nav-title, .meta {
                        display: none;
                    }

                    &.sub-header {
                        display: none;
                    }
                }
            }
        }
    }

    .controls {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #ccc;
        background-color: #ddd;
        padding: 0 1.5rem;
        height: 32px;
        overflow: hidden;
        color: #214367;

        span {
            cursor: pointer;
        }
    }
</style>
